import React from "react";

export default function MonoTextPreview({
  children,
}: {
  children: React.ReactNode;
}) {
  return <p className="prose-sm whitespace-pre-wrap font-mono">{children}</p>;
}
